import React from 'react';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import style from './style';

export default styled(
  ({ isLoading, color, flat, textColor, before, iconFloat, inverted, icon, copiedLabel, wasCopied, href, ...rest }) => (
    <Button {...rest} />
  ),
)`
  ${style};
`;
